<div class="flex items-center justify-center min-h-screen bg-white">
    <div class="w-full max-w-[500px] sm:min-w-[32rem] rounded-2xl p-8">
        <div class="w-full flex justify-center my-6">
            <img src="/assets/images/auth/interseed-new-logo.png" alt="interseed logo" class="h-16 w-auto" />
        </div>

        <div class="text-center mt-6">
            <p class="text-[#0A0A0A] text-[1.5rem]">Check your email</p>
            <p class="text-[#717182] text-[0.9rem] mt-2">We've sent a reset link to your email</p>
        </div>

        <div
            class="flex flex-col items-center w-full max-w-[500px] sm:min-w-[400px] rounded-2xl my-6 px-4 py-6 drop-shadow-black">
            <div class="p-4 bg-[#DCFCE7] rounded-full">
                <img
                    src="/assets/images/shared/tick-circle-green-icon.svg"
                    alt="tick circle green icon"
                    class="h-8 w-auto" />
            </div>

            <div class="space-y-1 my-6 text-center">
                <p class="text-[#717182] text-[1rem]">Click the link in the email to reset your password</p>
                <p class="text-[#717182] text-[1rem]">If you don't see the email, check your spam folder.</p>
            </div>

            <button type="submit" class="w-full border-button mt-4" [routerLink]="['/login']" [queryParams]="{ email }">
                Back to login
            </button>
        </div>
    </div>
</div>
